<template>
	<div class="info-content">
		<el-form label-width="80px">
			<el-form-item label="外边距">
				<el-input-number v-model="list.marginTop" placeholder="单位像素（px）" controls-position="right" :step="2" step-strictly></el-input-number>
			</el-form-item>
			<el-form-item label="内边距">
				<el-input-number v-model="list.paddingTop" placeholder="单位像素（px）" controls-position="right" :step="2" step-strictly></el-input-number>
			</el-form-item>
			<el-form-item label="左边距">
				<el-input-number v-model="list.paddingLeft" placeholder="单位'%'" controls-position="right" :step="1" step-strictly></el-input-number>
			</el-form-item>
			<el-form-item label="右边距">
				<el-input-number v-model="list.paddingRight" placeholder="单位'%'" controls-position="right" :step="1" step-strictly></el-input-number>
			</el-form-item>
			<el-form-item label="课程名称">
				<el-input v-model="list.catalogTitle" placeholder="课程名称" maxlength="13" show-word-limit></el-input>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" icon="el-icon-plus" class="add-image" @click="addList"> 添加列 </el-button>
			</el-form-item>
		</el-form>

		<el-form label-width="70px">
			<el-form-item class="listData" :label="'第' + (index + 1) + '项'" v-for="(item, index) in list.data" :key="index">
				<el-input v-model="list.data[index].title" placeholder="请输入标题" maxlength="9" show-word-limit></el-input>
				<el-input class="input_two" v-model="list.data[index].subTitle" placeholder="请输入副标题" maxlength="15" show-word-limit></el-input>
				<el-input class="input_two" v-model="list.data[index].videoUrl" placeholder="视频地址"></el-input>
				<el-button type="danger" icon="el-icon-delete" circle @click="deleteListData(index)"></el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
export default {
	name: 'courseCatalogue',
	props: ['data', 'className'],
	data() {
		return {
			list: {},
		};
	},
	mounted() {
		this.list = this.data;
	},
	methods: {
		addList() {
			var index = this.list.data.length + 1;
			this.list.data.push({ title: '', subTitle: '', videoUrl: '', model: 'text' + index });
		},
		// inputChange(val) {
		// 	// this.list = { ...this.list };
		// },
		deleteListData(val) {
			delete this.list.data.splice(val, 1);
			// this.inputChange();
		},
	},
};
</script>

<style scoped>
.info-content {
	padding: 20px;
	overflow-y: auto;
}
.listData .el-input {
	width: 160px;
}
.listData .el-button {
	float: right;
	margin-top: -40px;
}
.input_two {
	margin-top: 10px;
}

div /deep/ .el-upload-dragger {
	width: 120px;
	height: 80px;
}
div /deep/ .el-upload-dragger .el-icon-upload {
	margin-top: 15px;
}

.avatar {
	width: 120px;
	height: 80px;
	display: block;
}
</style>